<template>
  <Modal class="packs-verification" icon="car" :title="$t('packs.verification.title')" @close="$emit('close')">
    <template #text>
      <div class="packs-verification__info">
        <p class="packs-verification__description">
          {{ $t('packs.verification.description') }}
          <span class="packs-verification__username">{{ order.username }}</span>.
        </p>

        <!-- Аналог ErrorMessage type="info" — без заголовка, только текст -->
        <Alert state="warning" :info="$t('packs.verification.waiting')" />
      </div>

      <Button
        class="packs-verification__submit"
        size="lg"
        right-icon="/base/arrow-right.svg"
        :disabled="!order.verification_url"
        @click="openVerification"
      >
        {{ $t('packs.verification.button') }}
      </Button>
    </template>

    <template #footer>
      <Button type="secondary" right-icon="/base/support.svg" @click="openChat">
        {{ $t('packs.verification.helpBtn') }}
      </Button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Base/Modal/modal.vue'
import Button from '@/components/Base/Button/Button.vue'
import Alert from '@/components/Base/Alert/Alert.vue'
import { openChat } from '@/utils/chat'

export default {
  name: 'PacksVerification',
  components: { Modal, Button, Alert },
  props: {
    order: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    openChat,
    // Модалку НЕ закрываем: пользователь проходит проверку во внешней вкладке,
    // а здесь продолжает крутиться опрос статуса заказа.
    openVerification() {
      if (!this.order.verification_url) return

      window.open(this.order.verification_url, '_blank', 'noopener')
    }
  }
}
</script>

<style lang="scss" scoped>
.packs-verification {
  // Меньше пустого места сверху (как в остальных модалках паков)
  ::v-deep .modal__actions {
    margin-bottom: 4px;
  }

  ::v-deep .modal__close {
    height: 40px;
  }

  // Отступ между кнопкой действия (text) и кнопкой «Помощь» (footer)
  ::v-deep .modal__footer {
    margin-top: 12px;
  }

  // Текст и инфоблок держим ближе друг к другу, чем к кнопке
  &__info {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 24px;
  }

  &__description {
    font-size: 14px;
    font-weight: 500;
    line-height: 140%;
    color: var(--main-8);
  }

  &__username {
    font-weight: 600;
    color: #0077c3;
  }

  &__submit {
    width: 100%;
  }
}
</style>
